import { MessagePart } from '@gfe/core/services/gbe-error-parser/warning.model';
import { formatCompactDuration } from '@gfe/core/utils/time-utils';

/** The `YYYY-MM-DD` as written in an ISO date-time, with no time-zone conversion. */
const statedDay = (iso: string): string => iso.slice(0, 10);

/** The time of day as written in an ISO date-time ("09:16"), with no time-zone conversion. */
const statedTime = (iso: string): string => iso.slice(11, 16);

/** The one day every date-time of the occurrences states, or `null` when they differ or none exists. */
export function commonFindingDay(
  occurrences: readonly { parts?: MessagePart[] }[]
): string | null {
  const days = new Set<string>();
  for (const occurrence of occurrences) {
    for (const part of occurrence.parts ?? []) {
      if (part.kind === 'datetime') days.add(statedDay(part.iso));
    }
  }
  return days.size === 1 ? [...days][0] : null;
}

export function displayedPartText(part: MessagePart, sameDay: string | null): string {
  switch (part.kind) {
    case 'duration':
      return formatCompactDuration(part.iso);
    case 'datetime':
      return sameDay !== null && statedDay(part.iso) === sameDay
        ? statedTime(part.iso)
        : part.text;
    default:
      return part.text;
  }
}

/** The row as the reader sees it: what a search must match against. */
export function displayedText(
  parts: MessagePart[] | undefined,
  body: string,
  sameDay: string | null
): string {
  return parts ? parts.map((part) => displayedPartText(part, sameDay)).join('') : body;
}
